import DineshWickramasingheImage from '../assets/images/Testimonials/Dinesh-Wickremasinghe.png';
import DonKalImage from '../assets/images/Testimonials/Don-Kal.png';
import GanganathKaluarachchiImage from '../assets/images/Testimonials/Ganganath-Kaluarachchi.png';
import HasiniMadhuwanthiImage from '../assets/images/Testimonials/Hasini-Madhuwanthi.png';
import JayaniWickramageImage from '../assets/images/Testimonials/Jayani-Wickramage.png';
import JeewakaDinethImage from '../assets/images/Testimonials/Jeewaka-Dineth.png';
import NaveenMeddagodageImage from '../assets/images/Testimonials/Naveen-Meddagodage.png';
import PanchaliNathyaImage from '../assets/images/Testimonials/Panchali-nathya.png';
import ShameeImage from '../assets/images/Testimonials/Shamee.png';
import ThilankaGunawardenaImage from '../assets/images/Testimonials/Thilanka-Gunawardena.png';
import VajiraGunasekaraImage from '../assets/images/Testimonials/Vajira-Gunasekera.png';

const TestimonialsData = [
    {
        id: 1,
        dp: PanchaliNathyaImage,
        name: "Panchali Nathya",
        // title: "Hair loss",
        // country: "Russia",
        rating: 5,
        description: "I had the most relaxing experience at Ceylon Wellness today with a body and head massage. My masseuse, Heshani Sanjana, was absolutely wonderful! She was incredibly humble, professional, and provided exceptional service. Highly recommend Ceylon Wellness and Heshani for anyone looking for top-notch massage therapy..",
    },
    {
        id: 2,
        dp: JeewakaDinethImage,
        name: "Jeewaka Dineth",
        // title: "Back pain",
        // country: "Angoda",
        rating: 5,
        description: "I had lost faith in Sinhala medicine a long time ago. But for some reason I felt like coming here. And it was the best decision I made in a long time. They were able to changed the perspective I had on Sinhala medicine. The therapists are really nice and so friendly. The doctor I met, also so chill and friendly.",
    },
    {
        id: 3,
        dp: NaveenMeddagodageImage,
        name: "Naveen Meddagodage",
        // title: "Diabetes",
        // country: "India",
        rating: 5,
        description: "I recently visited Ceylon Hospital Wellness twice within the past three months and found the experience to be exceptional. The hospitality and treatments received were of the highest quality. Mr. Teras, my massage therapist, was particularly impressive.",
    },
    {
        id: 4,
        dp: ShameeImage,
        name: "Shamee",
        // title: "Pimples",
        // country: "Ampara",
        rating: 5,
        description: "The treatments offered are top-notch, and I could feel the difference after just a few sessions.The best part is the pricing it’s very reasonable for the quality of care you receive. Definitely a great choice for anyone seeking effective treatments at an affordable price!"
    },
    {
        id: 5,
        dp: ThilankaGunawardenaImage,
        name: "Thilanka Gunawardena",
        // title: "Pimples",
        // country: "Ampara",
        rating: 5,
        description: "We are truly satisfied with the package and the therapists, Mr. Terance and Ms. Rashmi. The hospitality and service were exceptional. The body massage was performed professionally and with great care, while the steam bath and scrub were incredibly refreshing."
    },
    {
        id: 6,
        dp: DonKalImage,
        name: "Don Kal",
        // title: "Pimples",
        // country: "Ampara",
        rating: 5,
        description: "Late reveiw. Terrance was absolutely professional in what he does. Highly recommended for anyone seeking relaxation and therapy. You wont regret it."
    },
    {
        id: 7,
        dp: DineshWickramasingheImage,
        name: "Dinesh Wickremasinghe",
        // title: "Pimples",
        // country: "Ampara",
        rating: 5,
        description: "Had a great experience. The best Ayuruvedic spa experience I have ever had. The therapists are well experienced and have very good knowledge. Highly recommended!"
    },
    {
        id: 8,
        dp: VajiraGunasekaraImage,
        name: "Vajira Gunasekera",
        // title: "Pimples",
        // country: "Ampara",
        rating: 5,
        description: "Superb  place.My favorite place for full body treatment and Therapist Terence  always gives me best treatment  Highly recommend."
    },
    {
        id: 9,
        dp: JayaniWickramageImage,
        name: "Jayani Wickramage",
        // title: "Pimples",
        // country: "Ampara",
        rating: 5,
        description: "Went for a full body massage for my father. Extraordinary service and a great experience."
    },
    {
        id: 10,
        dp: HasiniMadhuwanthiImage,
        name: "Hasini Madhuwanthi",
        // title: "Pimples",
        // country: "Ampara",
        rating: 5,
        description: "I booked a session for my parents. The staff was amazing, and the environment was relaxing. Highly recommended!"
    },
    {
        id: 11,
        dp: GanganathKaluarachchiImage,
        name: "Ganganath Kaluarachchi",
        // title: "Pimples",
        // country: "Ampara",
        rating: 5,
        description: "Terrance was absolutely professional in his work. Highly recommended for anyone seeking relaxation and therapy. You won’t regret it!"
    },
];

export default TestimonialsData